import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackCancelOrderParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/order/trackCancelOrder";

const useTrackCancelOrder = (
    parameters: TrackCancelOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.cancelOrder, parameters, options);
};

export default useTrackCancelOrder;
